// One-time notice for an employee with Remote Punch on: their location is
// recorded only at the moment they punch. Accepting is stored on the server.
import React, { useState } from "react";
import { MapPinned, Smartphone, MapPin, EyeOff } from "lucide-react";
import RemotePunchDialog, { dialogColors } from "../../../components/RemotePunch/RemotePunchDialog";
import { rpText } from "../../../components/RemotePunch/remotePunchText";

const POINT_ICONS = [Smartphone, MapPin, EyeOff];

const RemoteConsentModal = ({ open, onAccept, onClose, isDarkMode, language }) => {
  const t = rpText(language);
  const c = dialogColors(isDarkMode);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const accept = async () => {
    setBusy(true);
    setError(null);
    try {
      await onAccept();
    } catch (err) {
      setError(err?.message || String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <RemotePunchDialog
      open={open}
      onClose={onClose}
      title={t.consentTitle}
      subtitle={t.consentBody}
      icon={MapPinned}
      dark={isDarkMode}
      language={language}
      maxWidth={460}
      closeLabel={t.close}
      footer={
        <button
          type="button"
          onClick={accept}
          disabled={busy}
          style={{ width: "100%", padding: "12px 26px", borderRadius: 12, border: "none", background: c.primary, color: "#fff", fontSize: 15, fontWeight: 800, fontFamily: "inherit", cursor: busy ? "not-allowed" : "pointer", opacity: busy ? 0.7 : 1, boxShadow: `0 4px 14px ${c.primary}44` }}
        >
          {t.consentAccept}
        </button>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {t.consentPoints.map((text, i) => {
          const Icon = POINT_ICONS[i] || MapPin;
          return (
            <div key={text} style={{ display: "flex", gap: 12, alignItems: "flex-start", padding: "11px 13px", borderRadius: 12, background: c.soft, border: `1px solid ${c.border}` }}>
              <div style={{ width: 32, height: 32, flexShrink: 0, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", background: `${c.primary}1a`, color: c.primary }}>
                <Icon size={16} />
              </div>
              <div style={{ fontSize: 14, lineHeight: 1.7, fontWeight: 600 }}>{text}</div>
            </div>
          );
        })}
      </div>
      {error && <p style={{ margin: "12px 0 0", fontSize: 13, color: c.danger }}>{error}</p>}
    </RemotePunchDialog>
  );
};

export default RemoteConsentModal;
